export default __webpack_public_path__ + "static/media/notebook-icon-hover.82e1a291.svg";